/* Noctera — script unique. Genere depuis shopify/assets/*.js */

/* ===== hero ===== */
/* =============================================================
   Noctera - Hero "Fresh Morning" (section Shopify)
   Trois responsabilites, aucune dependance :
   1. lancer la sequence d'entree,
   2. ouvrir/fermer le menu mobile,
   3. animer la parallaxe pointeur.
   Chaque section s'initialise une seule fois et se reinitialise
   dans l'editeur de theme (shopify:section:load).
   ============================================================= */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var desktop = window.matchMedia('(min-width: 781px)');

  function init(hero) {
    if (!hero || hero.dataset.hmReady === 'true') return;
    hero.dataset.hmReady = 'true';

    /* --- 1. Sequence d'entree ---------------------------------
       On attend les polices : le masque du titre ne doit pas
       laisser passer une ligne mesuree avec la police de repli. */

    function play() {
      hero.classList.add('is-ready');
    }

    if (document.fonts && document.fonts.ready) {
      // Le filet de securite n'utilise pas requestAnimationFrame : dans un
      // onglet en arriere-plan les frames sont suspendues, la sequence doit
      // partir quand meme.
      var safety = setTimeout(play, 900);
      document.fonts.ready.then(function () {
        clearTimeout(safety);
        requestAnimationFrame(play);
      });
    } else {
      play();
    }

    /* --- 2. Menu mobile --------------------------------------- */

    var topbar = hero.querySelector('.topbar');
    var burger = hero.querySelector('.burger');
    var nav = hero.querySelector('.nav');

    if (topbar && burger && nav) {
      var setMenu = function (open) {
        topbar.classList.toggle('is-open', open);
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        burger.setAttribute('aria-label', burger.dataset[open ? 'labelClose' : 'labelOpen'] || '');
      };

      burger.addEventListener('click', function () {
        setMenu(!topbar.classList.contains('is-open'));
      });

      nav.addEventListener('click', function (event) {
        if (event.target.closest('a')) setMenu(false);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && topbar.classList.contains('is-open')) {
          setMenu(false);
          burger.focus();
        }
      });

      document.addEventListener('click', function (event) {
        if (topbar.classList.contains('is-open') && !topbar.contains(event.target)) setMenu(false);
      });

      // Le panneau mobile ne doit pas rester ouvert en passant sur desktop.
      desktop.addEventListener('change', function (event) {
        if (event.matches) setMenu(false);
      });
    }

    /* --- 3. Parallaxe pointeur --------------------------------
       Deux variables CSS (--px, --py) entre -1 et 1, lissees.
       Chaque couche les consomme avec son propre facteur : aucun
       transform n'est partage entre deux animations. */

    var frame = null;
    var target = { x: 0, y: 0 };
    var current = { x: 0, y: 0 };

    function loop() {
      current.x += (target.x - current.x) * 0.075;
      current.y += (target.y - current.y) * 0.075;

      hero.style.setProperty('--px', current.x.toFixed(4));
      hero.style.setProperty('--py', current.y.toFixed(4));

      if (Math.abs(target.x - current.x) > 0.001 || Math.abs(target.y - current.y) > 0.001) {
        frame = requestAnimationFrame(loop);
      } else {
        frame = null;
      }
    }

    function onMove(event) {
      target.x = (event.clientX / window.innerWidth) * 2 - 1;
      target.y = (event.clientY / window.innerHeight) * 2 - 1;
      if (frame === null) frame = requestAnimationFrame(loop);
    }

    function onLeave() {
      target.x = 0;
      target.y = 0;
      if (frame === null) frame = requestAnimationFrame(loop);
    }

    function syncParallax() {
      window.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerleave', onLeave);

      if (fine.matches && !reduced.matches) {
        window.addEventListener('pointermove', onMove, { passive: true });
        document.addEventListener('pointerleave', onLeave);
      } else {
        onLeave();
      }
    }

    syncParallax();
    fine.addEventListener('change', syncParallax);
    reduced.addEventListener('change', syncParallax);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-hero-morning]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Editeur de theme : la section est reinjectee a chaque modification.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

/* Fresh Morning motion controller for the sections after the hero. */
(function () {
  'use strict';

  var roots = new Map();
  var visible = new Set();
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var frame = 0;
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.target.classList.contains('faq__guarantees')) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-nc-seen');
          observer.unobserve(entry.target);
        }
        return;
      }
      if (entry.isIntersecting) visible.add(entry.target);
      else visible.delete(entry.target);
    });
    schedule();
  }, { rootMargin: '80px 0px 80px 0px' }) : null;

  function clamp(value) { return Math.max(0, Math.min(1, value)); }
  function schedule() {
    if (frame || document.hidden) return;
    frame = requestAnimationFrame(paint);
  }

  function paint() {
    frame = 0;
    if (document.hidden) return;
    var viewport = window.innerHeight;
    var small = window.innerWidth <= 940 || !fine.matches;
    var reads = [];
    visible.forEach(function (root) {
      var state = roots.get(root);
      if (!state) return;
      var rect = root.getBoundingClientRect();
      if (state.type === 'essentials') {
        var cards = state.cards.map(function (card) { return card.getBoundingClientRect(); });
        reads.push({ state: state, cards: cards, small: small, viewport: viewport });
      } else if (state.type === 'pack') {
        reads.push({ state: state, rect: rect, viewport: viewport, small: small });
      } else if (state.type === 'routine') {
        reads.push({ state: state, rect: rect, steps: state.steps.map(function (step) { return step.getBoundingClientRect(); }), viewport: viewport, small: small });
      }
    });

    reads.forEach(function (read) {
      var state = read.state;
      if (state.type === 'essentials') {
        var activeIndex = -1;
        if (read.small) {
          var distance = Infinity;
          read.cards.forEach(function (rect, index) {
            var delta = Math.abs((rect.top + rect.bottom) / 2 - read.viewport * .52);
            if (delta < distance) { distance = delta; activeIndex = index; }
          });
        } else {
          activeIndex = state.hovered;
        }
        state.cards.forEach(function (card, index) {
          var active = !reduced.matches && index === activeIndex;
          card.classList.toggle('is-nc-active', active);
          if (read.small || reduced.matches) {
            card.style.removeProperty('--nc-tilt-x');
            card.style.removeProperty('--nc-tilt-y');
          } else {
            card.style.setProperty('--nc-tilt-x', active ? (-state.pointerY * 3.2).toFixed(2) + 'deg' : '0deg');
            card.style.setProperty('--nc-tilt-y', active ? (state.pointerX * 3.2).toFixed(2) + 'deg' : '0deg');
          }
        });
      } else if (state.type === 'pack') {
        var progress = reduced.matches ? 1 : clamp((read.viewport * .88 - read.rect.top) / (read.viewport * .56 + read.rect.height * .44));
        var offsets = [-16, 18, 24];
        var vertical = [6, -7, 8];
        state.shots.forEach(function (shot, index) {
          var pointer = read.small || reduced.matches ? 0 : 1;
          var x = offsets[index] * (1 - progress) + state.pointerX * (index === 0 ? 6 : 3.5) * pointer;
          var y = vertical[index] * (1 - progress) + state.pointerY * (index === 0 ? 5 : 3) * pointer;
          shot.style.setProperty('--nc-shot-x', x.toFixed(1) + 'px');
          shot.style.setProperty('--nc-shot-y', y.toFixed(1) + 'px');
        });
      } else if (state.type === 'routine') {
        var progress = reduced.matches ? 1 : clamp((read.viewport * .78 - read.rect.top) / (read.rect.height + read.viewport * .18));
        var active = Math.min(state.steps.length - 1, Math.floor(progress * state.steps.length));
        if (read.small) {
          var nearest = Infinity;
          read.steps.forEach(function (rect, index) {
            var delta = Math.abs((rect.top + rect.bottom) / 2 - read.viewport * .52);
            if (delta < nearest) { nearest = delta; active = index; }
          });
        }
        state.steps.forEach(function (step, index) {
          var value = reduced.matches ? 1 : read.small
            ? clamp((read.viewport * .65 - read.steps[index].top) / (read.viewport * .5))
            : clamp(progress * (state.steps.length - 1) - index);
          step.style.setProperty('--nc-line-progress', value.toFixed(3));
          step.classList.toggle('is-nc-active', reduced.matches || index === active);
        });
      }
    });
  }

  function mount(root, type) {
    if (roots.has(root)) return;
    var state = { root: root, type: type, hovered: -1, pointerX: 0, pointerY: 0, cleanup: [] };
    if (type === 'essentials') {
      state.cards = Array.prototype.slice.call(root.querySelectorAll('.ecard'));
      state.cards.forEach(function (card, index) {
        function move(event) {
          if (!fine.matches || reduced.matches) return;
          var rect = card.getBoundingClientRect();
          state.hovered = index;
          state.pointerX = clamp((event.clientX - rect.left) / rect.width) * 2 - 1;
          state.pointerY = clamp((event.clientY - rect.top) / rect.height) * 2 - 1;
          schedule();
        }
        function leave() { state.hovered = -1; state.pointerX = state.pointerY = 0; schedule(); }
        card.addEventListener('pointermove', move, { passive: true });
        card.addEventListener('pointerleave', leave, { passive: true });
        state.cleanup.push(function () { card.removeEventListener('pointermove', move); card.removeEventListener('pointerleave', leave); });
      });
    } else if (type === 'pack') {
      var visual = root.querySelector('.pack__visual');
      state.shots = Array.prototype.slice.call(root.querySelectorAll('.pack__shot'));
      if (visual) {
        function move(event) {
          if (!fine.matches || reduced.matches) return;
          var rect = visual.getBoundingClientRect();
          state.pointerX = clamp((event.clientX - rect.left) / rect.width) * 2 - 1;
          state.pointerY = clamp((event.clientY - rect.top) / rect.height) * 2 - 1;
          schedule();
        }
        function leave() { state.pointerX = state.pointerY = 0; schedule(); }
        visual.addEventListener('pointermove', move, { passive: true });
        visual.addEventListener('pointerleave', leave, { passive: true });
        state.cleanup.push(function () { visual.removeEventListener('pointermove', move); visual.removeEventListener('pointerleave', leave); });
      }
    } else if (type === 'routine') {
      state.steps = Array.prototype.slice.call(root.querySelectorAll('.step'));
    }
    roots.set(root, state);
    root.dataset.ncMotion = type;
    if (observer) observer.observe(root);
    else visible.add(root);
    if (type === 'faq') {
      var guarantees = root.querySelector('.faq__guarantees');
      if (guarantees) {
        if (observer) observer.observe(guarantees);
        else guarantees.classList.add('is-nc-seen');
      }
    }
    schedule();
  }

  function scan(scope) {
    var definitions = [
      ['[data-reveal-essentials]', 'essentials'],
      ['[data-reveal-pack]', 'pack'],
      ['[data-reveal-routine]', 'routine'],
      ['[data-reveal-faq]', 'faq']
    ];
    definitions.forEach(function (definition) {
      if (scope.matches && scope.matches(definition[0])) mount(scope, definition[1]);
      scope.querySelectorAll(definition[0]).forEach(function (root) { mount(root, definition[1]); });
    });
  }

  function unmount(scope) {
    roots.forEach(function (state, root) {
      if (root !== scope && !scope.contains(root)) return;
      if (observer) {
        observer.unobserve(root);
        var guarantees = root.querySelector('.faq__guarantees');
        if (guarantees) observer.unobserve(guarantees);
      }
      visible.delete(root);
      state.cleanup.forEach(function (dispose) { dispose(); });
      roots.delete(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  else scan(document);
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(); });
  reduced.addEventListener('change', schedule);
  fine.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { unmount(event.target); });
})();

/* ===== problems ===== */
/* =============================================================
   Noctera - Section « Problemes sommeil » (Shopify)
   Une seule responsabilite : declencher la cascade quand la
   section entre dans le champ, puis se deconnecter. Plus rien
   ne tourne ensuite.
   ============================================================= */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer = null;

  function show(section) {
    section.classList.add('is-in');
  }

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        show(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      // Le seuil est pose sur la marge, pas sur un ratio : la cascade part
      // quand le haut de la section atteint 82 % de la hauteur d'ecran,
      // quelle que soit la hauteur de la section ou du telephone.
      rootMargin: '0px 0px -18% 0px',
      threshold: 0
    });
    return observer;
  }

  function init(section) {
    if (section.dataset.hmpReady === 'true') return;
    section.dataset.hmpReady = 'true';

    // Sans IntersectionObserver, ou en mouvement reduit, on affiche tout de suite.
    if (!('IntersectionObserver' in window) || reduced.matches) {
      show(section);
      return;
    }

    getObserver().observe(section);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-reveal-section]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Editeur de theme : la section est reinjectee a chaque modification.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

/* ===== essentials ===== */
/* =============================================================
   Noctera - Section « Nos essentiels sommeil » (Shopify)
   Une seule responsabilite : declencher la cascade quand la
   section entre dans le champ, puis se deconnecter.
   ============================================================= */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer = null;

  function show(section) {
    section.classList.add('is-in');
  }

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        show(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      // Le seuil est pose sur la marge, pas sur un ratio : la cascade part
      // quand le haut de la section atteint 82 % de la hauteur d'ecran,
      // quelle que soit la hauteur de la section ou du telephone.
      rootMargin: '0px 0px -18% 0px',
      threshold: 0
    });
    return observer;
  }

  function init(section) {
    if (section.dataset.hmeReady === 'true') return;
    section.dataset.hmeReady = 'true';
    section.classList.add('is-js');

    // Sans IntersectionObserver, ou en mouvement reduit, on affiche tout de suite.
    if (!('IntersectionObserver' in window) || reduced.matches) {
      show(section);
      return;
    }

    getObserver().observe(section);
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-reveal-essentials]')) init(scope);
    scope.querySelectorAll('[data-reveal-essentials]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Editeur de theme : la section est reinjectee a chaque modification.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

/* ===== pack ===== */
/* =============================================================
   Noctera - Section « Pack Routine Sommeil » (Shopify)
   Une seule responsabilite : declencher l'apparition quand la
   section entre dans le champ, puis se deconnecter.
   ============================================================= */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer = null;

  function show(section) {
    section.classList.add('is-in');
  }

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        show(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      // Le seuil est pose sur la marge, pas sur un ratio : l'apparition part
      // quand le haut de la section atteint 82 % de la hauteur d'ecran,
      // quelle que soit la hauteur de la section ou du telephone.
      rootMargin: '0px 0px -18% 0px',
      threshold: 0
    });
    return observer;
  }

  function init(section) {
    if (section.dataset.hmkReady === 'true') return;
    section.dataset.hmkReady = 'true';
    section.classList.add('is-js');

    // Sans IntersectionObserver, ou en mouvement reduit, on affiche tout de suite.
    if (!('IntersectionObserver' in window) || reduced.matches) {
      show(section);
      return;
    }

    getObserver().observe(section);
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-reveal-pack]')) init(scope);
    scope.querySelectorAll('[data-reveal-pack]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Editeur de theme : la section est reinjectee a chaque modification.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

/* ===== routine ===== */
/* =============================================================
   Noctera - Section « Votre routine en 3 etapes » (Shopify)
   Une seule responsabilite : declencher la progression quand la
   section entre dans le champ, puis se deconnecter.
   ============================================================= */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer = null;

  function show(section) {
    section.classList.add('is-in');
  }

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        show(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      // Le seuil est pose sur la marge, pas sur un ratio : la progression part
      // quand le haut de la section atteint 82 % de la hauteur d'ecran,
      // quelle que soit la hauteur de la section ou du telephone.
      rootMargin: '0px 0px -18% 0px',
      threshold: 0
    });
    return observer;
  }

  function init(section) {
    if (section.dataset.hmrReady === 'true') return;
    section.dataset.hmrReady = 'true';
    section.classList.add('is-js');

    // Sans IntersectionObserver, ou en mouvement reduit, on affiche tout de suite.
    if (!('IntersectionObserver' in window) || reduced.matches) {
      show(section);
      return;
    }

    getObserver().observe(section);
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-reveal-routine]')) init(scope);
    scope.querySelectorAll('[data-reveal-routine]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Editeur de theme : la section est reinjectee a chaque modification.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

/* ===== reviews ===== */
/* =============================================================
   Noctera - Section « Avis clients » (Shopify)
   Une seule responsabilite : declencher la cascade quand la
   section entre dans le champ, puis se deconnecter.
   ============================================================= */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer = null;

  function show(section) {
    section.classList.add('is-in');
  }

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        show(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      // Le seuil est pose sur la marge, pas sur un ratio : la cascade part
      // quand le haut de la section atteint 82 % de la hauteur d'ecran,
      // quelle que soit la hauteur de la section ou du telephone.
      rootMargin: '0px 0px -18% 0px',
      threshold: 0
    });
    return observer;
  }

  function init(section) {
    if (section.dataset.hmaReady === 'true') return;
    section.dataset.hmaReady = 'true';

    // Sans IntersectionObserver, ou en mouvement reduit, on affiche tout de suite.
    if (!('IntersectionObserver' in window) || reduced.matches) {
      show(section);
      return;
    }

    getObserver().observe(section);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-reveal-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Editeur de theme : la section est reinjectee a chaque modification.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

/* ===== newsletter ===== */
/* =============================================================
   Noctera - Section « Offre de bienvenue » (Shopify)
   Une seule responsabilite : declencher l'apparition quand la
   section entre dans le champ, puis se deconnecter.

   L'inscription elle-meme n'a besoin d'aucun script : c'est
   {% form 'customer' %} qui poste, et Liquid qui rend le message
   de succes au rechargement.
   ============================================================= */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer = null;

  function show(section) {
    section.classList.add('is-in');
  }

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        show(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      // Le seuil est pose sur la marge, pas sur un ratio : l'apparition part
      // quand le haut de la section atteint 82 % de la hauteur d'ecran.
      rootMargin: '0px 0px -18% 0px',
      threshold: 0
    });
    return observer;
  }

  function init(section) {
    if (section.dataset.hmnReady === 'true') return;
    section.dataset.hmnReady = 'true';
    section.classList.add('is-js');

    // Sans IntersectionObserver, ou en mouvement reduit, on affiche tout de suite.
    if (!('IntersectionObserver' in window) || reduced.matches) {
      show(section);
      return;
    }

    getObserver().observe(section);
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-reveal-offer]')) init(scope);
    scope.querySelectorAll('[data-reveal-offer]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Editeur de theme : la section est reinjectee a chaque modification.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

/* ===== faq ===== */
/* =============================================================
   Noctera - Section « Questions frequentes » (Shopify)
   Deux responsabilites :
   1. l'apparition au scroll ;
   2. l'accordeon : une classe et un aria-expanded, rien de plus.
      La hauteur est animee par la grille CSS, jamais mesuree ici.
   ============================================================= */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer = null;

  function show(section) {
    section.classList.add('is-in');
  }

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        show(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      // Le seuil est pose sur la marge, pas sur un ratio : l'apparition part
      // quand le haut de la section atteint 82 % de la hauteur d'ecran.
      rootMargin: '0px 0px -18% 0px',
      threshold: 0
    });
    return observer;
  }

  function accordion(section) {
    section.querySelectorAll('.faq__item').forEach(function (item) {
      var button = item.querySelector('.faq__q');
      if (!button) return;

      // L'etat de depart vient du balisage : sans JavaScript tout est ouvert,
      // avec JavaScript seul ce qui porte .is-open le reste.
      button.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');

      button.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function init(section) {
    if (section.dataset.hmfReady === 'true') return;
    section.dataset.hmfReady = 'true';

    accordion(section);
    section.classList.add('is-js');

    // Sans IntersectionObserver, ou en mouvement reduit, on affiche tout de suite.
    if (!('IntersectionObserver' in window) || reduced.matches) {
      show(section);
      return;
    }

    getObserver().observe(section);
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-reveal-faq]')) init(scope);
    scope.querySelectorAll('[data-reveal-faq]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Editeur de theme : la section est reinjectee a chaque modification.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

/* ===== footer ===== */
/* =============================================================
   Noctera - Pied de page (Shopify)
   Une seule responsabilite : declencher l'apparition quand le pied
   de page entre dans le champ, puis se deconnecter.

   L'annee du copyright est rendue par Liquid, pas ici : elle est
   donc juste meme si le script ne part jamais.
   ============================================================= */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer = null;

  function show(el) {
    el.classList.add('is-in');
  }

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        show(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      // Marge plus courte que sur les sections : un pied de page est souvent
      // le dernier element de la page, il ne remonte jamais tres haut a l'ecran.
      rootMargin: '0px 0px -8% 0px',
      threshold: 0
    });
    return observer;
  }

  function init(foot) {
    if (foot.dataset.hmbReady === 'true') return;
    foot.dataset.hmbReady = 'true';
    foot.classList.add('is-js');

    // Sans IntersectionObserver, ou en mouvement reduit, on affiche tout de suite.
    if (!('IntersectionObserver' in window) || reduced.matches) {
      show(foot);
      return;
    }

    getObserver().observe(foot);
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-reveal-foot]')) init(scope);
    scope.querySelectorAll('[data-reveal-foot]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Editeur de theme : la section est reinjectee a chaque modification.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

/* ===== product ===== */
/* =============================================================
   Noctera - Page produit « Fresh Morning » (Shopify)
   Cinq responsabilites, aucune dependance :
   1. lancer la sequence d'entree,
   2. ouvrir/fermer le menu mobile,
   3. changer la photo principale depuis les miniatures,
   4. incrementer/decrementer la quantite,
   5. suivre la variante choisie (prix, photo, disponibilite, id envoye).
   Les montants sont deja formates par Liquid : ce script ne connait
   aucune regle de devise.
   ============================================================= */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer = null;

  /* ---------- 1. Entree ---------- */

  function show(section) {
    section.classList.add('is-in');
  }

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        show(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -18% 0px', threshold: 0 });
    return observer;
  }

  /* ---------- 2. Menu mobile ---------- */

  function wireBurger(section, teardown) {
    var bar = section.querySelector('.pdp__topbar');
    var burger = section.querySelector('.pdp__burger');
    if (!bar || !burger) return;

    function close() {
      bar.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      var label = burger.dataset.labelOpen;
      if (label) burger.setAttribute('aria-label', label);
    }

    burger.addEventListener('click', function () {
      var open = bar.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      var label = open ? burger.dataset.labelClose : burger.dataset.labelOpen;
      if (label) burger.setAttribute('aria-label', label);
    });

    // Un lien touche ferme le menu. `closest('a')` et pas la classe de
    // lien : le bouton « Produits » (un <summary>) porte lui aussi
    // pdp__nav-link pour l'apparence, et fermer le menu sur ce tap
    // empechait d'ouvrir le sous-menu (meme regle que le hero).
    bar.addEventListener('click', function (event) {
      if (event.target.closest('a')) close();
    });

    // Echap : l'ecouteur vit sur document, donc il doit etre retire au
    // dechargement de la section, sinon l'editeur de theme en empile un par
    // modification (c'est la dette deja constatee sur le hero).
    function onKey(event) {
      if (event.key !== 'Escape' || !bar.classList.contains('is-open')) return;
      close();
      burger.focus();
    }
    document.addEventListener('keydown', onKey);
    teardown.push(function () { document.removeEventListener('keydown', onKey); });

    function onOutside(event) {
      if (!bar.classList.contains('is-open')) return;
      if (bar.contains(event.target)) return;
      close();
    }
    document.addEventListener('click', onOutside);
    teardown.push(function () { document.removeEventListener('click', onOutside); });

    // Repasser en desktop laisserait sinon un menu ouvert invisible.
    var wide = window.matchMedia('(min-width: 781px)');
    function onWide(event) { if (event.matches) close(); }
    if (wide.addEventListener) {
      wide.addEventListener('change', onWide);
      teardown.push(function () { wide.removeEventListener('change', onWide); });
    }
  }

  /* ---------- 3. Galerie ---------- */

  function setPhoto(photo, src, srcset, alt) {
    if (!photo || !src) return;
    // srcset d'abord : sinon le navigateur peut resservir l'ancien candidat.
    if (srcset) { photo.srcset = srcset; } else { photo.removeAttribute('srcset'); }
    photo.src = src;
    if (alt) photo.alt = alt;
  }

  function markThumb(thumbs, active) {
    thumbs.forEach(function (thumb) {
      var on = thumb === active;
      thumb.classList.toggle('is-active', on);
      if (on) {
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.removeAttribute('aria-current');
      }
    });
  }

  function wireGallery(section) {
    var photo = section.querySelector('[data-pdp-photo]');
    var thumbs = section.querySelectorAll('[data-pdp-thumb]');
    if (!photo || !thumbs.length) return null;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        markThumb(thumbs, thumb);
        setPhoto(photo, thumb.dataset.full, thumb.dataset.srcset, thumb.dataset.alt);
      });
    });

    return thumbs;
  }

  /* ---------- 4. Quantite ---------- */

  function wireQuantity(section) {
    var field = section.querySelector('[data-pdp-qty-field]');
    if (!field) return;

    function floor() {
      var min = parseInt(field.min, 10);
      return isNaN(min) ? 1 : min;
    }

    section.querySelectorAll('[data-pdp-qty]').forEach(function (button) {
      button.addEventListener('click', function () {
        var step = parseInt(button.dataset.pdpQty, 10) || 0;
        var min = floor();
        var next = (parseInt(field.value, 10) || min) + step;
        if (next < min) next = min;
        field.value = next;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Saisie manuelle : on refuse le vide et les valeurs sous le minimum.
    field.addEventListener('change', function () {
      var min = floor();
      var value = parseInt(field.value, 10);
      if (isNaN(value) || value < min) field.value = min;
    });
  }

  /* ---------- 5. Variantes ---------- */

  function readVariants(section) {
    var holder = section.querySelector('[data-pdp-variants]');
    if (!holder) return [];
    try {
      var parsed = JSON.parse(holder.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      // Un JSON casse ne doit pas emporter le reste de la page.
      return [];
    }
  }

  function sameOptions(variant, chosen) {
    if (!variant.options || variant.options.length !== chosen.length) return false;
    for (var i = 0; i < chosen.length; i++) {
      if (variant.options[i] !== chosen[i]) return false;
    }
    return true;
  }

  function wireVariants(section, thumbs) {
    var selects = section.querySelectorAll('[data-pdp-option]');
    if (!selects.length) return;

    var variants = readVariants(section);
    if (!variants.length) return;

    var idField = section.querySelector('[data-pdp-variant-id]');
    var priceNow = section.querySelector('[data-pdp-price-now]');
    var priceWas = section.querySelector('[data-pdp-price-was]');
    var priceWasValue = section.querySelector('[data-pdp-price-was-value]');
    var save = section.querySelector('[data-pdp-save]');
    var atc = section.querySelector('[data-pdp-atc]');
    var atcLabel = section.querySelector('[data-pdp-atc-label]');
    var status = section.querySelector('[data-pdp-status]');
    var photo = section.querySelector('[data-pdp-photo]');

    // Les deux libelles viennent du Liquid : lire celui affiche ne marcherait
    // pas si le produit est deja epuise au chargement.
    var labelAdd = (atc && atc.dataset.addLabel) || (atcLabel ? atcLabel.textContent.trim() : '');
    var labelOut = (atc && atc.dataset.soldOutLabel) || 'Indisponible';

    function syncThumb(src) {
      if (!thumbs || !src) return;
      thumbs.forEach(function (thumb) {
        if (thumb.dataset.full === src) markThumb(thumbs, thumb);
      });
    }

    var first = true;

    function apply() {
      // Au premier passage on synchronise sans rien annoncer : la region
      // role="status" ne doit parler que sur une action de l'acheteur.
      var announce = !first;
      first = false;

      var chosen = [];
      selects.forEach(function (select) { chosen.push(select.value); });

      var match = null;
      for (var i = 0; i < variants.length; i++) {
        if (sameOptions(variants[i], chosen)) { match = variants[i]; break; }
      }

      if (!match) {
        // Combinaison inexistante : on bloque l'ajout plutot que d'envoyer un id faux.
        if (atc) atc.disabled = true;
        if (atcLabel) atcLabel.textContent = labelOut;
        if (status && announce) status.textContent = 'Cette combinaison n’existe pas.';
        return;
      }

      if (idField) idField.value = match.id;
      if (priceNow) priceNow.textContent = match.price;

      if (priceWas) {
        if (match.compare) {
          if (priceWasValue) priceWasValue.textContent = match.compare;
          priceWas.hidden = false;
        } else {
          priceWas.hidden = true;
        }
      }

      if (save) {
        if (match.save) {
          save.textContent = 'Économie ' + match.save;
          save.hidden = false;
        } else {
          save.hidden = true;
        }
      }

      if (atc) atc.disabled = !match.available;
      if (atcLabel) atcLabel.textContent = match.available ? labelAdd : labelOut;
      if (status && announce) {
        status.textContent = match.available
          ? match.price + ', disponible.'
          : match.price + ', ' + labelOut.toLowerCase() + '.';
      }

      if (match.image && photo) {
        setPhoto(photo, match.image, '', match.alt || photo.alt);
        syncThumb(match.image);
      }

      // L'URL suit la variante : partage et rechargement restent coherents.
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    selects.forEach(function (select) {
      select.addEventListener('change', apply);
    });

    // Un rechargement doux restaure la valeur des <select> mais pas celle du
    // champ cache : sans cet appel, l'id envoye peut ne pas correspondre a ce
    // que l'acheteur voit.
    apply();
  }

  /* ---------- Initialisation ---------- */

  var teardowns = {};

  function init(section) {
    if (section.dataset.hmdReady === 'true') return;
    section.dataset.hmdReady = 'true';

    var teardown = [];
    teardowns[section.id] = teardown;

    wireBurger(section, teardown);
    var thumbs = wireGallery(section);
    wireQuantity(section);
    wireVariants(section, thumbs);

    // Sans IntersectionObserver, ou en mouvement reduit, on affiche tout de suite.
    if (!('IntersectionObserver' in window) || reduced.matches) {
      show(section);
      return;
    }

    getObserver().observe(section);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-reveal-product]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Editeur de theme : la section est reinjectee a chaque modification.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    (event.target.querySelectorAll ? event.target.querySelectorAll('[data-reveal-product]') : []).forEach(function (section) {
      var list = teardowns[section.id];
      if (!list) return;
      list.forEach(function (fn) { fn(); });
      delete teardowns[section.id];
    });
  });
})();

/* ===== store ===== */
/* =============================================================
   Noctera - Ecrans boutique « Fresh Morning » (Shopify)
   Trois responsabilites, aucune dependance :
   1. lancer la sequence d'entree,
   2. ouvrir/fermer le menu mobile de l'en-tete global,
   3. renvoyer le formulaire du panier quand une quantite change.
   Tout fonctionne deja sans ce script : les boutons +/- du panier
   sont de vrais liens /cart/change, et le bouton « Mettre a jour »
   reste affiche tant que la classe is-js n'est pas posee.
   ============================================================= */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer = null;
  var teardowns = {};

  /* ---------- 1. Entree ---------- */

  function show(section) {
    section.classList.add('is-in');
  }

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        show(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });
    return observer;
  }

  /* ---------- 2. Menu mobile ---------- */

  function wireBurger(section, teardown) {
    var bar = section.querySelector('.st__topbar');
    var burger = section.querySelector('.st__burger');
    if (!bar || !burger) return;

    function close() {
      bar.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      var label = burger.dataset.labelOpen;
      if (label) burger.setAttribute('aria-label', label);
    }

    burger.addEventListener('click', function () {
      var open = bar.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      var label = open ? burger.dataset.labelClose : burger.dataset.labelOpen;
      if (label) burger.setAttribute('aria-label', label);
    });

    // `closest('a')` et pas .st__nav-link : le bouton « Produits » (un
    // <summary>) porte aussi cette classe, et fermer le menu sur ce tap
    // empechait d'ouvrir le sous-menu (meme regle que le hero).
    bar.addEventListener('click', function (event) {
      if (event.target.closest('a')) close();
    });

    // Ecouteurs sur document : ils doivent etre retires au dechargement
    // de la section, sinon l'editeur de theme en empile un par modification.
    function onKey(event) {
      if (event.key !== 'Escape' || !bar.classList.contains('is-open')) return;
      close();
      burger.focus();
    }
    document.addEventListener('keydown', onKey);
    teardown.push(function () { document.removeEventListener('keydown', onKey); });

    function onOutside(event) {
      if (!bar.classList.contains('is-open')) return;
      if (bar.contains(event.target)) return;
      close();
    }
    document.addEventListener('click', onOutside);
    teardown.push(function () { document.removeEventListener('click', onOutside); });

    var wide = window.matchMedia('(min-width: 781px)');
    function onWide(event) { if (event.matches) close(); }
    if (wide.addEventListener) {
      wide.addEventListener('change', onWide);
      teardown.push(function () { wide.removeEventListener('change', onWide); });
    }
  }

  /* ---------- 3. Quantites du panier ---------- */

  function wireCart(section) {
    var fields = section.querySelectorAll('[data-st-qty-field]');
    if (!fields.length) return;

    fields.forEach(function (field) {
      field.addEventListener('change', function () {
        var min = parseInt(field.min, 10);
        if (isNaN(min)) min = 0;
        var value = parseInt(field.value, 10);
        if (isNaN(value) || value < min) {
          field.value = min;
          value = min;
        }
        // Le formulaire porte name="updates[]" ligne par ligne : le renvoyer
        // suffit, Shopify recalcule le panier entier.
        var form = field.form;
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    });
  }

  /* ---------- Initialisation ---------- */

  function init(section) {
    if (section.dataset.hmsReady === 'true') return;
    section.dataset.hmsReady = 'true';

    var teardown = [];
    teardowns[section.id] = teardown;

    wireBurger(section, teardown);
    wireCart(section);

    if (!('IntersectionObserver' in window) || reduced.matches) {
      show(section);
      return;
    }

    getObserver().observe(section);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-reveal-store]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    (event.target.querySelectorAll ? event.target.querySelectorAll('[data-reveal-store]') : [])
      .forEach(function (section) {
        var list = teardowns[section.id];
        if (!list) return;
        list.forEach(function (fn) { fn(); });
        delete teardowns[section.id];
      });
  });
})();

/* ===== nav dropdown ===== */

/* Noctera — menu deroulant « Produits »
   ---------------------------------------------------------------------------
   Le composant est un <details> : il s'ouvre, se ferme et se pilote au clavier
   sans une ligne de script. Ce fichier n'ajoute que le confort, et chaque
   morceau est optionnel :

     - fermer quand on clique ailleurs dans la page ;
     - fermer sur Echap et rendre le focus au bouton ;
     - fermer des qu'un item est choisi, pour que le panneau ne reste pas
       ouvert par-dessus la section vers laquelle on defile ;
     - n'en garder qu'un seul ouvert a la fois.

   Le defilement, lui, n'est PAS fait ici : les items sont de vrais liens vers
   des ancres (#produits, #pack) et `scroll-behavior: smooth`, pose par
   theme.liquid, s'en charge — y compris sans JavaScript. */

(function () {
  'use strict';

  var drops = Array.prototype.slice.call(
    document.querySelectorAll('[data-nc-navdrop]')
  );
  if (!drops.length) return;

  function closeAll(except) {
    drops.forEach(function (drop) {
      if (drop !== except) drop.open = false;
    });
  }

  drops.forEach(function (drop) {
    drop.addEventListener('toggle', function () {
      if (drop.open) closeAll(drop);
    });

    Array.prototype.forEach.call(
      drop.querySelectorAll('.nc-navdrop__link'),
      function (link) {
        link.addEventListener('click', function () { drop.open = false; });
      }
    );
  });

  document.addEventListener('click', function (event) {
    var inside = event.target.closest && event.target.closest('[data-nc-navdrop]');
    if (!inside) closeAll(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    drops.forEach(function (drop) {
      if (!drop.open) return;
      // Ne reprendre le focus que si l'utilisateur etait DANS ce menu :
      // sinon Echap, partage avec les burgers mobiles, arracherait le
      // focus a l'element que le burger vient de refocaliser.
      var refocus = drop.contains(document.activeElement);
      drop.open = false;
      var button = drop.querySelector('summary');
      if (button && refocus) button.focus();
    });
  });
})();

/* ===== expert ===== */

/* =============================================================
   Noctera — Section « Explication routine sommeil »
   Meme principe que les autres sections, sur son propre attribut :
   chaque section reste independante des autres.
   ============================================================= */

(function () {
  'use strict';

  var sections = document.querySelectorAll('[data-reveal-expert]');
  if (!sections.length) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function show(section) {
    section.classList.add('is-in');
  }

  // Sans IntersectionObserver, ou en mouvement reduit, on affiche tout de suite.
  if (!('IntersectionObserver' in window) || reduced.matches) {
    Array.prototype.forEach.call(sections, show);
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      show(entry.target);
      observer.unobserve(entry.target);
    });
  }, {
    rootMargin: '0px 0px -18% 0px',
    threshold: 0
  });

  Array.prototype.forEach.call(sections, function (section) {
    observer.observe(section);
  });
})();
